import IRole from "../types/role-type";
import api from "./auth-interceptor";

class RoleService {
  getAllRoles() {
    return api.get("roles");
  }

  getUserRole(id: string): Promise<IRole[]> {
    return api.get(`users/${id}/roles`);
  }

  updateUserRoles(id: string, newRoles: IRole[]): Promise<void> {
    return api.put(`users/${id}/roles`, { roles: newRoles });
  }
}

const roleService = new RoleService();
export default roleService;
